module.exports = __webpack_public_path__ + "assets/img/gangkou.0867bb15.png";